import { useState } from "react";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

export function useFormSubmit() {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const submit = async (apiFn, { successTitle, successText, onSuccess, onError } = {}) => {
    setIsLoading(true);
    try {
      await apiFn();
      setIsLoading(false);
      await Swal.fire({
        title: successTitle || t("_request_placed"),
        text: successText,
        confirmButtonColor: "#032C65",
        confirmButtonText: t("_accept"),
        background: "#f7f8fa",
      });
      if (onSuccess) onSuccess();
      window.scrollTo({ top: 0, behavior: "smooth" });
    } catch (err) {
      setIsLoading(false);
      console.error(err);
      Swal.fire({
        title: t("_oops"),
        text: t("_form_error_body"),
        icon: "error",
        confirmButtonColor: "#032C65",
        confirmButtonText: t("_accept"),
        background: "#f7f8fa",
      });
      if (onError) onError(err);
    }
  };

  return { isLoading, submit };
}
